/* Component Dependencies */
var capacityChartTemplate = require('templates/capacityChart.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'capacityChart',
    template: {
        'capacityChart': capacityChartTemplate
    },
    events: {
        'click .unit-conversion': 'unitConversion',
        'click .reset-chart': 'resetChart',
        'click .alphabetic-sort': "alphaNumericSort",
        'click .sorting-row': "sortChart",
        'click .l-area-heading': "areaSort"
    },

    /**
     * This function is used to swap data-attr and the text
     *
     **/
    settingAttrTextValue: function _settingAttrTextValue(element, index, dataAttr) {
        var currentElement = this.$el.find(element).eq(index),
            elemAttr = currentElement.attr(dataAttr),
            elemText = currentElement.text();
        if (elemText) {
            currentElement.text(elemAttr);
        }
        currentElement.attr(dataAttr, elemText);
    },

    /**
     * This function is used to convert the sqFeets to sqMeters or vise-versa
     *
     **/
    unitConversion: function _unitConversion(event) {
        if (event) {
            event.preventDefault();
        }
        var _self = this,
            $elm = _self.$el,
            headingLabel = $elm.find('.l-area-heading').attr('data-squnit'),
            dataHeadingLabel = $elm.find('.l-area-heading span').text();
        _self.settingAttrTextValue('.unit-conversion', 0, "data-unit");
        $elm.find('.l-area-heading').attr('data-squnit', dataHeadingLabel).end()
            .find('.l-area-heading span').text(headingLabel);
        $elm.find('.l-area').each(function(index) {
            var areaLabel = $elm.find('.l-area').eq(index).attr("data-areaLabel");
            _self.settingAttrTextValue('.l-area', index, "data-unit");
            _self.settingAttrTextValue('.l-dimensions', index, "data-dimensions");
            $elm.find('.l-area').eq(index).attr("data-title", areaLabel + " " + headingLabel);
        });
    },

    /*
     * This function is to Re-arrange the list.
     *
     **/
    reArrangeList: function _reArrangeList() {
        var _self = this,
            $elm = _self.$el,
            chartWrapper = $elm.find(".l-capicity-chart-description");
        chartHeading = $elm.find(".l-chart-heading");
        chartWrapper.empty().append(chartHeading);
    },

    /*
     * This function is to Sort the list in Numeric, Alphabetic, alphaNumberic order.
     *
     **/
    sortingList: function _sortingList(chartItems, isNumeric, sortType) {
        var _self = this,
            val1, val2;

        if (isNumeric) {
            chartItems.sort(function(firstItem, secondItem) {
                var firstVal = parseInt(($(firstItem).text()).replace(',', '')),
                    secondVal = parseInt(($(secondItem).text()).replace(',', ''));
                if (sortType === "descending") {
                    val1 = secondVal ? secondVal : 0;
                    val2 = firstVal ? firstVal : 0;
                } else {
                    val1 = firstVal ? firstVal : 0;
                    val2 = secondVal ? secondVal : 0;
                }
                return  (val1)  <  (val2)  ?  1  :  -1;
            }).parent().appendTo(".l-capicity-chart-description");
        } else {
            chartItems.sort(function(firstItem, secondItem) {
                if (sortType === "descending") {
                    val1 = $(secondItem).text().toUpperCase();
                    val2 = $(firstItem).text().toUpperCase();
                } else {
                    val1 = $(firstItem).text().toUpperCase();;
                    val2 = $(secondItem).text().toUpperCase();;
                }

                return _self.alphaNumricSorter(val1, val2);
            }).parent().appendTo(".l-capicity-chart-description");

        }
    },

    /**
     * This function is used to Reset Load State.
     *
     **/
    resetChart: function _resetChart(event) {
        event.preventDefault();
        var _self = this,
            $elm = this.$el,
            chartItems = $elm.find(".chart-items-js"),
            headingLabel = $elm.find('.unit-conversion').attr('data-title'),
            dataHeadingLabel = $elm.find('.unit-conversion').text();
        if (!(headingLabel === dataHeadingLabel)) {
            _self.unitConversion();
        }
        _self.reArrangeList();
        chartItems.sort(function(firstItem, secondItem) {
            return  ($(secondItem).data('index'))  <  ($(firstItem).data('index'))  ?  1  :  -1;
        }).appendTo(".l-capicity-chart-description");
    },

    /**
     * This function is used to retrieve the Meeting room list.
     *
     **/
    alphaNumericSort: function _alphaNumericSort(e) {
        e.preventDefault();
        var _self = this,
            $elm = _self.$el,
            chartItems = $elm.find(".meeting-room-name");
        _self.sortList(e, false, chartItems);
    },

    /**
     * This function is used to retrieve the Numeric list for sorting.
     *
     **/
    sortChart: function _sortChart(e) {
        e.preventDefault();
        var _self = this,
            $elm = _self.$el,
            sortList = $(e.target).text(),
            chartItems;
        if(sortList.split(" ").length) {
            sortList = sortList.split(" ")[0];
        }else {
            sortList = sortList;
        }
        chartItems = $elm.find("." + sortList);
        if ($elm.find('.' + sortList + '.is-blank').length === chartItems.length) {
            return;
        } else {
            _self.sortList(e, true, chartItems);
        }
    },

    /**
     * This function is used to retrieve the Area list for sorting.
     *
     **/
    areaSort: function _areaSort(e) {
        e.preventDefault();
        var _self = this,
            $elm = _self.$el,
            chartItems = $elm.find(".l-area");
        _self.sortList(e, true, chartItems);
    },

    /**
     * This function is used to Toggel the sort and retrieve the Sort Order.
     *
     **/
    sortList: function _sortList(e, listValueType, list) {
        var _self = this,
            sortType,
            parentElement,
            isListEmpty;
        if ($(e.target).prop("tagName") === 'LI') {
            parentElement = $(e.target).find('a');
        } else if ($(e.target).prop("tagName") === 'SPAN') {
            parentElement = $(e.target).parent();
        } else {
            parentElement = $(e.target);
        }
        parentElement.hasClass("descending") ? sortType = "descending" : sortType = "ascending";
        _self.reArrangeList();
        _self.sortingList(list, listValueType, sortType);
        parentElement.toggleClass("ascending descending");
    },
    /**
     *This function is to Sort the list in alphaNumberic order
     */
    alphaNumricSorter: function _alphaNumricSorter(a, b) {
        var reA = /[^a-zA-Z0-9]/g,
            aA, bA;
        aA = a.replace(reA, "");
        bA = b.replace(reA, "");
        return aA > bA ? 1 : -1;
    }
});